module.exports = __webpack_public_path__ + "img/spring_trip-20160416-21-1024x576.164b0420.jpg";